import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { RouterModule, Routes } from '@angular/router';
import { AttendanceRoutingModule } from './attendance-routing.module';
import { MaterialModule } from '../material.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

// Components
import { EmployeeManagementComponent } from './employee-management/employee-management.component';
import { ClockInOutComponent } from './clock-in-out/clock-in-out.component';
import { AttendanceReportComponent } from './attendance-report/attendance-report.component';
import { SalaryManagementComponent } from './salary-management/salary-management.component';
import { AttendanceImportComponent } from './attendance-import/attendance-import.component';
import { AttendanceIndividualPunchImportComponent } from './attendance-individual-punch-import/attendance-individual-punch-import.component';
import { MonthlyAttendanceReportComponent } from './monthly-attendance-report/monthly-attendance-report.component';
import { ManualAttendanceEntryComponent } from './manual-attendance-entry/manual-attendance-entry.component';
import { SalaryPaymentDialogComponent } from './salary-management/salary-payment-dialog.component';
import { AttendanceDashboardComponent } from './attendance-dashboard/attendance-dashboard.component';
import { AttendanceMainDashboardComponent } from './attendance-main-dashboard/attendance-main-dashboard.component';
import { DeviceManagementComponent } from './device-management/device-management.component';
import { ConfirmationDialogComponent } from './device-management/confirmation-dialog.component';
import { ImportConflictDialogComponent } from './attendance-individual-punch-import/import-conflict-dialog/import-conflict-dialog.component';

// Services
import { AttendanceService } from '../services/attendance.service';

/*const routes: Routes = [
  {
    path: 'attendance',
    children: [
      {
        path: 'employees',
        component: EmployeeManagementComponent,
        data: { title: 'Employee Management' }
      },
      {
        path: 'clock-in-out',
        component: ClockInOutComponent,
        data: { title: 'Clock In/Out' }
      },
      {
        path: 'reports',
        component: AttendanceReportComponent,
        data: { title: 'Attendance Reports' }
      },
      {
        path: 'salary',
        component: SalaryManagementComponent,
        data: { title: 'Salary Management' }
      },
      {
        path: '',
        redirectTo: 'employees',
        pathMatch: 'full'
      }
    ]
  }
];*/

@NgModule({
  declarations: [
    EmployeeManagementComponent,
    ClockInOutComponent,
    AttendanceReportComponent,
    SalaryManagementComponent,
    AttendanceImportComponent,
    AttendanceIndividualPunchImportComponent,
    MonthlyAttendanceReportComponent,
    ManualAttendanceEntryComponent,
    SalaryPaymentDialogComponent,
    AttendanceDashboardComponent,
    AttendanceMainDashboardComponent,
    DeviceManagementComponent,
    ConfirmationDialogComponent,
    ImportConflictDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatSnackBarModule,
    MatIconModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    //RouterModule.forChild(routes)
    AttendanceRoutingModule
  ],
  providers: [
    AttendanceService
  ],
  exports: [
    EmployeeManagementComponent,
    ClockInOutComponent,
    AttendanceReportComponent,
    SalaryManagementComponent
  ]
})
export class AttendanceModule { } 